import { useEffect, useState } from "react";

function BotonContacto({ children }) {
    const [link, setLink] = useState({});
    useEffect(() => {
        fetch("/links.json")
            .then(res => res.json())
            .then(data => {
                const activo = data.links.find(l => l.activo === true);
                if (activo) {
                    const urlCompleta = `${activo.url}${activo.numero}&text=${encodeURIComponent(data.mensaje)}`;
                    setLink({
                        nombre: activo.nombre,
                        url: urlCompleta
                    });
                }
            });
    }, []);
    return children(link);
}

export default BotonContacto;